module.exports = __webpack_public_path__ + "static/img/no-record-icon.a51f872.png";


//////////////////
// WEBPACK FOOTER
// ./static/fxView/images/no-record-icon.png
// module id = UwrI
// module chunks = 68